export default __webpack_public_path__ + "static/media/0x5c4b7ccbf908e64f32e12c6650ec0c96d717f03f.72e24e3c.webp";